import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Table = styled.table`
    width: 100%;
    /* height: 100%; */
    table-layout: fixed;

    @media (min-width: ${({theme}) => theme.size.tablet}) and (max-width: ${({theme}) => theme.size.laptop}) {
        width: 99%;
    }
`;

export const YounovLink = styled(Link)`
    color: ${({ theme,color }) => color?color:theme.colors.lightBlack};
    text-decoration: none;
    &:hover{
        color: ${({ theme }) => theme.colors.secondary};
    }
`

export const Badge = styled.span`
  
font-size: 0.875rem !important;
line-height: 1.5;
    width: 40px !important;
    padding: 1px 0px 1px 0px;
    color: #344767;
    border-style: solid;
    border-width: 1px;
    border-color:  ${({ theme, bd }) => bd ? bd : theme.colors.primary};
    background-color: #ffffff;
    border-radius: 8px;
    text-align: center;


`

export const TD = styled.td`

    padding: 0.25rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.textBody};
    line-height: 1.4;
        font-size: 0.875rem;
        font-weight: 600;
            letter-spacing: -0.025rem;
      
    & > span {
        display: block;
        width: 100%;
        overflow: hidden; 
        text-overflow: ellipsis;
        white-space: nowrap;
    }
      @media ${({ theme }) => theme.device.mobileL} {
        font-size: 0.8rem;
         white-space: wrap;
        
    }
`

export const TBody = styled.tbody`
    width: 100%;
    font-size: 0.9rem;
    color: ${({theme}) => theme.colors.lightBlack};

    tr {
        border-bottom: 0.0rem solid white;
    }

    & ${TD} {
        width: 100%;
        vertical-align: middle;
        height: ${({height}) => height ? height : '100%'};
    }
`;

export const SpinnerContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1rem 0;
`;

export const NoContent = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    color: ${({theme}) => theme.colors.secondary};
    margin: 1rem 0;
`

export const TAContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
`;

export const TableAction = styled.div`
    display: flex;
    justify-content: space-between ;
    align-items: center;
    height: 40px;
    margin-left: 1rem;
    padding: 0.5rem 1.6rem;
   /* border: 1px solid #cb0c9f ;*/
    border-radius: 8px;
    //color: ${({theme}) => theme.colors.lightBlack};
    cursor: pointer;
    font-size: 0.9rem;

    & span {
        color: ${({ theme }) => theme.colors.lightBlack};
        margin: 0 0.5rem 0 0;
    }

    &:hover {    
        /* border: 2px solid ${({ theme }) => theme.colors.btnBorder};*/
         opacity: 0.9;
         & span {
             color:  ${({ theme }) => theme.colors.btnBorder} !important;
            opacity: 0.7;
            }
    }
`;

export const TableActionLink = styled(Link)`
    display: flex;
    justify-content: space-between ;
    align-items: center; 
    height: 40px;
    margin-left: 1rem;
    padding: 0.5rem 1.6rem;
    border: 1px solid ${({theme}) => theme.colors.btnBorder};
    text-decoration: none;
    border-radius: 8px;
   
    border: 1px solid ${({ theme, border }) => (border ? border : theme.colors.content)};

    color: ${({ theme, color }) => (color ? color : theme.colors.content)}; 

    background-color:${({ theme, bg }) => (bg ? bg : theme.colors.content)};

    cursor: pointer;
    font-size: 0.75rem;

    & span {
     color: ${({ theme, color }) => (color ? color : theme.colors.content)};
     font-weight: 700;
     line-height: 1.4;
     font-size: 0.75rem;
     letter-spacing: -0.025rem;
     text-transform: uppercase;
     margin: 0 0.5rem 0 0;
     
    }

    &:hover {
        border: 2px solid ${({ theme }) => theme.colors.primary};
         opacity: 0.99;
    }
  

    @media (max-width: ${({ theme }) => theme.size.laptopL}) {
      padding: 0.3rem 0.5rem;
      font-size:0.75rem;
      margin-left: 0.175rem;
  }
`;

export const THead  = styled.thead`
    width: 100%;
    color: ${({theme}) => theme.colors.secondary};
    font-size: 0.9rem;
    background-color: #FFFFFF;
    
     @media ${({ theme }) => theme.device.mobileL} {
        font-size: 0.8rem;
        
    }
`

export const TH = styled.th`
    width: ${({width}) => width || 'auto'};
    padding-bottom: 0 0.25rem 1rem 0.25rem;
   
    border-right: 2px solid #fff;
    color: ${({ theme }) => theme.colors.younovGray};
    line-height: 1.4;
    letter-spacing: -0.025rem;
    text-transform: uppercase;
    
`

export const THContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    cursor: pointer;
  

    & > span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;

         color: ${({ theme }) => theme.colors.younovGray};
     
        line-height: 1.4;
        font-size: 0.75rem;
            letter-spacing: -0.025rem;
        text-transform: uppercase;
    }
` 

export const FilterContainer = styled.div`
    display: flex;
    //width: 100%;
    align-items: center;
    padding-right: 0.5rem;
`

export const SelectFilter = styled.select`
    width: 100%;
    height: 100%;
    border: none;
    border-bottom: 2px solid ${({theme}) => theme.colors.secondary};
    outline: none;
    color: #505050 !important;
    font-size: 0.9rem;
    background-color: #FFFFFF;
    cursor: pointer;

    &:hover {
        border-bottom: 2px solid ${({theme}) => theme.colors.primary};
    }
    &::placeholder {
        color: ${({theme}) => theme.colors.gray};
        font-style: italic;
    }

`

export const Option = styled.option`
    width: 100%;
`

export const InputFilter = styled.input`
    width: 100%;
    height: 100%;
    border: none;
    border-bottom: 2px solid ${({theme}) => theme.colors.secondary};
    outline: none;
    color: #505050 !important;
    font-size: 0.8rem;
    background-color: #FFFFFF;

    &:hover {
        border-bottom: 2px solid ${({theme}) => theme.colors.primary};
    }

    &:focus {
        border-bottom: 2px solid ${({theme}) => theme.colors.primary};
    }
    &::placeholder {
        color: ${({theme}) => theme.colors.gray};
        font-style: italic;
    }
`

export const SearchInputContainer = styled.div`
    display: flex;
    align-items: center;
    height: 50px;
    padding: 0.5rem 1rem;
    border: 2px solid #D9E1E7;
    border-radius: 16px;
    color: #D9E1E7;
    margin-right: 1rem;
`

export const SearchInput = styled.input`
    border: none;
    outline: none;
    color: ${({theme}) => theme.colors.lightBlack};
    font-size: 0.8rem;
    
    &::placeholder {
        color: ${({theme}) => theme.colors.primary} !important;
        font-style: italic;
    }
    &:focus-within {
        // border: 2px solid #2174B9;
        color: ${({theme}) => theme.colors.lightBlack};
    }
`



